var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/stock.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ba1147a0!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/stock.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Stock.vue
// module id = 743
// module chunks = 1